class utilitiesListeResultat {
	constructor(config) {
		/// On surcharge {config} par {defaults}
		/// les propriétés de {defaults} ne sont ajoutées que si elles n'existent pas
		this.config = config
	}
	offset(elem) {
		var rect = elem.getBoundingClientRect(),
			bodyElem = document.body;
		return {
			bottom: rect.bottom,
			height: rect.height,
			top: rect.top + bodyElem.scrollTop,
			left: rect.left + bodyElem.scrollLeft
		}
	}

	is_touch_enabled() {
		return "ontouchstart" in document.documentElement;
	}

	isHashed(hash) {
		return location.hash === hash ? true : false;
	}

	isObjectEmpty(obj) {
		return Object.keys(obj).length === 0 && obj.constructor === Object
	}

	showMore(container = '', selector, classToggle, hasHtmlContent, states) {
		let self = this;

		const libelle = states || {
			true: 'Afficher plus',
			false: 'Afficher moins'
		}
		let delay = settingsListeResultats.delay;

		// On masque le contenu avec un décalage
		setTimeout(function () {
			document.querySelectorAll(`${container} [data-hide="true"]`).forEach(el => {
				// Cas Présentation
				if (el.querySelector('.bloc__descriptif') !== null) {
					let nbLignesAffichees = +getComputedStyle(el).getPropertyValue('--nblines'),
						hauteurLigne = parseInt(getComputedStyle(el).lineHeight, 10),
						hauteurBloc = self.offset(el.querySelector('.bloc__descriptif')).height;

					/// Si la hauteur du bloc non masqué > (Nombre de lignes affichées + 1) * hauteur d'une ligne
					/// on masque les lignes 2 + n
					/// sinon on masque le bouton 'Lire la suite'
					if (hauteurBloc > nbLignesAffichees * hauteurLigne) {
						el.classList.add('is-overflow');
					} else {
						try {
							el.querySelector('[data-toggle]').remove();
						} catch {

						}
					}
				} else {
					el.classList.add('is-overflow');
				}
			});
		}, delay);

		document.querySelectorAll(`${container} ${selector}`).forEach(el => {
			el.addEventListener('click', function (e) {

				e.target.parentElement.classList.toggle(classToggle);
				e.target.dataset.toggle = !JSON.parse(e.target.dataset.toggle);
				/// On garde le <svg>
				if (hasHtmlContent) {
					if (!self.isObjectEmpty(libelle)) {
						e.target.childNodes[1].nodeValue = libelle[e.target.dataset.toggle];
					}
				} else {
					e.target.textContent = libelle[e.target.dataset.toggle];
				}
				if (e.target.dataset.parent === 'infosPays') {
					let event = new CustomEvent(`show:widget`, {
						bubbles: true,
						cancelable: true,
						detail: selector
					});

					// Dispatch the event
					document.dispatchEvent(event);
				}

			})
		});
	}
}